import React from 'react';
import {Box, Button, Flex, Text} from '@chakra-ui/react';
import {AddLarge, TrashCan} from '@carbon/icons-react';
import {AccountFilterCondition} from '../../../shared/filter/accountFilter';
import {AccountFilterGroupDraft} from '../filterTypes';
import {OperatorElement} from './OperatorElement';
import {FilterConditionContent} from './FilterControl';
import {useFilterStore} from '../filterStore';

export const FilterGroupControl = ({
  group,
  availableOptions,
  onRemove,
  staticTagsOnly,
}: {
  group: AccountFilterGroupDraft;
  availableOptions: AccountFilterCondition['field'][];
  onRemove: () => void;
  staticTagsOnly?: boolean;
}) => {
  const {
    addConditionToGroup,
    updateConditionInGroup,
    removeConditionFromGroup,
    updateFilterGroupOperator,
  } = useFilterStore();

  const conditionText = group.operator === 'and' ? 'All' : 'Any';

  return (
    <Box
      flex={1}
      border="1px solid"
      borderColor="kgray.200"
      borderRadius="md"
      bg="kgray.100"
    >
      <Flex justifyContent="space-between" alignItems="center" py={1} px={3}>
        <Text color="kgray.700">
          {conditionText} of the following are true...
        </Text>
        <Flex>
          <Button
            p={0}
            mr={2.5}
            size="sm"
            variant="ghost"
            onClick={() => addConditionToGroup(group.id)}
          >
            <AddLarge size={16} />
          </Button>
          <Button p={0} size="sm" variant="ghost" onClick={onRemove}>
            <TrashCan size={16} />
          </Button>
        </Flex>
      </Flex>

      <Flex gap={3} flexDirection="column" p={3}>
        {group.conditions.map((conditionWithId, index) => (
          <Flex
            alignItems="flex-start"
            flex={1}
            key={conditionWithId.id}
            gap={2}
          >
            <Box width="85px" flexShrink={0}>
              <OperatorElement
                operator={group.operator}
                isEditable={index === 0}
                onOperatorChange={(operator) =>
                  updateFilterGroupOperator(group.id, operator)
                }
              />
            </Box>
            <FilterConditionContent
              condition={conditionWithId.item}
              availableOptions={availableOptions}
              onUpdate={(c) =>
                updateConditionInGroup(group.id, conditionWithId.id, c)
              }
              onRemove={() =>
                removeConditionFromGroup(group.id, conditionWithId.id)
              }
              staticTagsOnly={staticTagsOnly}
            />
          </Flex>
        ))}
      </Flex>
    </Box>
  );
};
